import { render } from "./ProProdutosAvulsosView.vue?vue&type=template&id=620fa06f&scoped=true"
import script from "./ProProdutosAvulsosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosAvulsosView.vue?vue&type=script&lang=js"

import "./ProProdutosAvulsosView.vue?vue&type=style&index=0&id=620fa06f&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620fa06f"]])

export default __exports__